import Icon from './Icon';

// The "התקבלה כרטסת" mark: beside a supplier's name in the desktop table, at
// the end of the row's meta line on the phone list. Icon only (Ora asked for
// no text), the explanation lives in the hover tooltip. A click opens the
// ledger and must not bubble into the row's own click (which navigates into the
// supplier / opens the mobile sheet). A span with role="button", not a native
// button element: the mobile ListRow is itself a button, and buttons don't
// nest. On a phone and tablet the C14 hit area gives it a 44px tap box,
// anchored so it never covers the name (index.css).
export default function LedgerMark({ ledger, onOpen }) {
  if (!ledger) return null;
  const label = `התקבלה כרטסת עד ${coveredThroughLabel(ledger.covered_through)} — לחצי לצפייה`;
  return (
    <span
      role="button"
      tabIndex={0}
      className="ledger-mark"
      aria-label={label}
      onClick={(e) => { e.stopPropagation(); onOpen(ledger.id); }}
      onKeyDown={(e) => {
        if (e.key !== 'Enter' && e.key !== ' ') return;
        e.preventDefault();
        e.stopPropagation();
        onOpen(ledger.id);
      }}
    >
      <Icon name="list" size={15} />
      <span className="dn-tip" aria-hidden="true">{label}</span>
    </span>
  );
}

// 'YYYY-MM' → 'DD/MM/YYYY' of that month's last day ("עד 30/09/2026").
export function coveredThroughLabel(ym) {
  const [y, m] = String(ym || '').split('-').map(Number);
  if (!y || !m) return '';
  const last = new Date(y, m, 0).getDate();
  return `${String(last).padStart(2, '0')}/${String(m).padStart(2, '0')}/${y}`;
}
